"use strict";function startAuth$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.startAuth$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.verify.startAuth";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.5.21"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.21"},_a)),exports.startAuth$=startAuth$,exports.default=startAuth$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/verify/startAuth.js
// module id = 1037
// module chunks = 106